import React from "react";
import { ExternalLinkIcon } from "./ExternalLinkIcon";

/**
 * Shared "Learn more about Information Pages" link.
 * @param {{ className?: string }} props
 */
export function LearnMoreLink({ className }) {
	return (
		<a
			className={className}
			href="https://www.plusscommunities.com/information-feature"
			target="_blank"
			rel="noopener"
		>
			Information Pages
			<ExternalLinkIcon />
		</a>
	);
}
